/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */
let BaseURL = "";
let BaseURLV2 = "";
let BaseMediaURL = "";

// if (process.env.NODE_ENV == 'production') {
//     BaseURL = "https://api.zibatran.com/api";
//     BaseURLV2 = "https://api.zibatran.com/api/v2";
//     BaseMediaURL = "https://dl.zibatran.com/";
// } else {
//     BaseURL = "http://127.0.0.1:8084/api";
//     BaseURLV2 = "http://127.0.0.1:8084/api/v2";
//     BaseMediaURL = "http://127.0.0.1:8084/";
// }

const preferredURL = localStorage.getItem("preferredURL");

BaseURL = preferredURL !== null ? preferredURL : process.env.REACT_APP_API_URL;
BaseURLV2 = preferredURL !== null ? preferredURL + '/v2': process.env.REACT_APP_API_URL_V2;
BaseMediaURL = preferredURL !== null ? preferredURL : process.env.REACT_APP_API_BASE_MEDIA_URL;

export const GlobalAPIRoutes = {
  RecaptchaSiteKey: `6LfSeegZAAAAALATa5IPmzanqofmwCvTy53JBSHB`,
  TinyMCKey: "ndznbiakg6vifhgo9om132tv5pw62jjtkpsyqdhpdsey6yjr",
  BaseBlogURL: `${window.location.origin}/school/`,
  BaseVideoPlayURL: "https://api.isoogh.ir/uploads/videos/",
  // BaseMediaURL: "https://dl.zibatran.com/",
  BaseMediaURL: BaseMediaURL,
  GetWebinarLink: `${BaseURLV2}/lessons/open-webinar`,
  CreateNewExamQuestion: `${BaseURLV2}/exam/question`,
  UpdateExamQuestion: `${BaseURLV2}/exam/question/edit`,
  SearchExamQuestion: `${BaseURLV2}/exam/question/search`,
  BaseFilesURL: `https://api.isoogh.ir/`,
  BaseURL: `https://api.isoogh.ir/api`,
  BaseURLV2: `https://api.isoogh.ir/api/v2`,
};

export const PublicAPIRoutes = {
  GetFAQ: `${BaseURLV2}/faqs/get-faqs`,
  Auth: `${BaseURL}/auth/login`,
  ForgetPassword: `${BaseURL}/auth/password/forget`,
  ResetPassword: `${BaseURL}/auth/password/reset`,
  OTP: `${BaseURL}/auth/verify-otp`,
  CheckUsername: `${BaseURL}/auth/check-username`,
  CheckSsn: `${BaseURL}/auth/check-ssn`,
  StudentRegister: `${BaseURL}/auth/register/student`,
  ParentRegister: `${BaseURL}/auth/register/parent`,
  TeacherRegister: `${BaseURL}/auth/register/teacher`,
  AdviserRegister: `${BaseURL}/auth/register/adviser`,
  AssistantRegister: `${BaseURL}/auth/register/assistant`,
  RequestConsultation: `${BaseURLV2}/general/consultation/store`,
  ManagerRegister: `${BaseURL}/auth/register/school`,
  GetSchoolBlogAbout: `${BaseURLV2}/blog/public/get-about?parent_id=1&username=`,
  GetSchoolBlogNews: `${BaseURLV2}/blog/public/get-content?parent_id=1&username=`,
  GetSchoolBlogNewsDetail: `${BaseURLV2}/blog/public/get-content/news/detail/?username=`,
  GetSchoolBlogContentsDetail: `${BaseURLV2}/blog/public/get-content/content/detail/?username=`,
  GetSchoolBlogFestivalsDetail: `${BaseURLV2}/blog/public/get-festivals/detail/?username=`,
  GetSchoolBlogAlbumsDetail: `${BaseURLV2}/blog/public/get-galleries/detail?username=`,
  GetSchoolBlogAlbums: `${BaseURLV2}/blog/public/get-galleries?parent_id=0&username=`,
  GetSchoolBlogFestivals: `${BaseURLV2}/blog/public/get-festivals?parent_id=0&username=`,
  GetSchoolBlogContents: `${BaseURLV2}/blog/public/get-content?parent_id=2&username=`,
  GetSchoolBlogIndex: `${BaseURLV2}/blog/public/get-index?&username=`,
  GetNotifications: `${BaseURLV2}/notification/`,
  GetVgItems: `${BaseURLV2}/videograms`,
  GetEvents: `${BaseURLV2}/personal-event-pub/get-events`,
  GetUserEvents: `${BaseURLV2}/personal-event-pub/get-events-user/`,
  GetFollowers: `${BaseURLV2}/personal-event/get-followers`,
  GetEventsItem: `${BaseURLV2}/personal-event-pub/get-events-item`,
  MyEventFollow: `${BaseURLV2}/personal-event/follow`,
  MyEventUnFollow: `${BaseURLV2}/personal-event/unfollow`,
  MyEventCheckFollow: `${BaseURLV2}/personal-event/check-follow`,
  AddVgCooment: `${BaseURLV2}/videograms/add-comment`,
  EventBuy: `${BaseURLV2}/personal-event-pub/buy-event`,
};

export const AdminAPIRoutes = {
  AddNewFAQ: `${BaseURLV2}/faqs/create-faq`,
  GetStudents: `${BaseURL}/admin/students/get`,
  GetParents: `${BaseURL}/admin/parents/get`,
  GetManagers: `${BaseURL}/admin/managers/get`,
  GetTeachers: `${BaseURL}/admin/teachers/get`,
  GetAdvisers: `${BaseURL}/admin/advisers/get`,
  GetAssistants: `${BaseURL}/admin/assistants/get`,
  SwitchUser: `${BaseURLV2}/admin/switch-to-user-admin`,
  AdminCallback: `${BaseURLV2}/admin/switch-callback-admin`,
  GetVgItems: `${BaseURLV2}/videograms/all`,
  CreateVgItem: `${BaseURLV2}/videograms/create`,
  VgFileUpload: `${BaseURLV2}/videograms/file-upload`,
  VgVideoUpload: `${BaseURLV2}/videograms/video-upload`,
  VgUploadedFile: `${BaseURLV2}/videograms/uploaded-file`,
  DeleteVideogramItems: `${BaseURLV2}/videograms/delete`,
  GetVideogramCategories: `${BaseURLV2}/videograms/categories/get`,
  CreateVgCategory: `${BaseURLV2}/videograms/categories/create`,
  DeleteVideogramCategory: `${BaseURLV2}/videograms/categories/delete`,

  GetVideogramComments: `${BaseURLV2}/videograms/comments/get`,
};

export const SchoolManagerAPIRoutes = {
  SwitchAsStudent: `${BaseURLV2}/admin/switch-to-user`,
  SwitchBackAsManager: `${BaseURLV2}/admin/switch-callback`,
  ManagerEditBlogProfile: `${BaseURLV2}/blog/host/update`,
  Grades: `${BaseURLV2}/general/grades`,
  GetAllSupportForms: `${BaseURLV2}/support-form/get-all-support-forms`,
  SchoolGrades: `${BaseURLV2}/grades/get-grades`,
  SchoolClassrooms: `${BaseURLV2}/classrooms/get-classrooms?page=`,
  SearchUser: `${BaseURLV2}/general/search-user`,
  GetParentTags: `${BaseURLV2}/parent-tags/get-parents`,
  UpdateParentTag: `${BaseURLV2}/parent-tags/update`,
  SearchUserByUsername: `${BaseURLV2}/general/search-by-username`,
  SearchClass: `${BaseURLV2}/general/search-class`,
  CreateClassroom: `${BaseURLV2}/classrooms/create-classrooms`,
  UploadClassroomFiles: `${BaseURLV2}/classrooms/upload-classroom-files`,
  GetClassroomFiles: `${BaseURLV2}/classrooms/get-class`,
  RemoveClassroomFiles: `${BaseURLV2}/classrooms/remove-classroom-files`,
  UploadLessonFiles: `${BaseURLV2}/lessons/upload-lesson-files`,
  RemoveLessonFiles: `${BaseURLV2}/lessons/remove-lesson-files`,
  GetLessonFiles: `${BaseURLV2}/lessons/get-lesson`,
  AddStudentInClassroomJob: `${BaseURLV2}/classrooms/add-student-job`,
  AddStudentInClassroom: `${BaseURLV2}/classrooms/add-student`,
  DeleteClassroom: `${BaseURLV2}/classrooms/delete-classrooms`,
  DeleteAllStudents: `${BaseURLV2}/classrooms/delete-all-students`,
  ClassroomStudents: `${BaseURLV2}/classrooms/get-classroom-students`,
  UploadUserTagsExcel: `${BaseURLV2}/import-excel/users/tags`,
  ClassroomLessons: `${BaseURLV2}/lessons/get-lessons`,
  GetAllParentTags: `${BaseURLV2}/parent-tags/get`,
  JointExam: `${BaseURLV2}/total-exam`,
  SchoolsList: `${BaseURLV2}/school/list`,
  Events: `${BaseURLV2}/school/`,
  Messages: `${BaseURLV2}/school/`,
  GetAvailableLessonsForExam: `${BaseURLV2}/lessons/general/lessons`,
  LessonRecords: `${BaseURLV2}/lessons/get-recordings?page=`,
  ClassroomSessionComments: `${BaseURLV2}/sessions/get-questions`,
  ClassroomSessionAddComment: `${BaseURLV2}/sessions/set-question`,
  ClassroomSessions: `${BaseURLV2}/sessions/get-sessions?page=`,
  ClassroomSession: `${BaseURLV2}/sessions/session-detail`,
  CreateSession: `${BaseURLV2}/sessions/create-session`,
  DeleteSession: `${BaseURLV2}/sessions/delete-session`,
  DeleteStudentFromClassroom: `${BaseURLV2}/classrooms/delete-student`,
  DeleteLesson: `${BaseURLV2}/lessons/delete-lesson`,
  DeleteParentTags: `${BaseURLV2}/parent-tags/delete`,
  GetBlogValidate: `${BaseURLV2}/blog/host/get-host`,
  CreateBlog: `${BaseURLV2}/blog/host/create`,
  SearchCategory: `${BaseURLV2}/blog/category/search`,
  CreateCategory: `${BaseURLV2}/blog/category/create`,
  GetBlogPosts: `${BaseURLV2}/blog/content/get-contents?page=`,
  GetBlogAlbums: `${BaseURLV2}/blog/gallery/get-galleries?page=`,
  GetBlogFestivals: `${BaseURLV2}/blog/festival/get-festivals?page=`,
  GetFestivalArtEffectsList: `${BaseURLV2}/blog/festival/works/get-festival-works?page=`,
  GetPublicFestivalArtEffectsList: `${BaseURLV2}/blog/public/get-festivals/works/`,
  GetFestivalArtEffectDetail: `${BaseURLV2}/blog/festival/works/detail`,
  GetFestivalArtEffectComments: `${BaseURLV2}/blog/festival/works/comments/get-comments`,
  GetPublicFestivalArtEffectDetail: `${BaseURLV2}/blog/public/get-festivals/works/`,
  CheckFestivalAccess: `${BaseURLV2}/blog/festival/works/check-access`,
  JoinFestivalDraft: `${BaseURLV2}/blog/festival/works/draft`,
  AddFestivalArtEffect: `${BaseURLV2}/blog/festival/works/update`,
  NewPostDraft: `${BaseURLV2}/blog/content/draft`,
  NewAlbumDraft: `${BaseURLV2}/blog/gallery/draft`,
  NewFestivalDraft: `${BaseURLV2}/blog/festival/draft`,
  DisablePost: `${BaseURLV2}/blog/content/trash`,
  EnablePost: `${BaseURLV2}/blog/content/undo`,
  EnableGallery: `${BaseURLV2}/blog/gallery/undo`,
  EnableFestival: `${BaseURLV2}/blog/festival/undo`,
  GetSubCategory: `${BaseURLV2}/blog/category/get-categories`,
  UpdatePost: `${BaseURLV2}/blog/content/update`,
  UpdateAlbum: `${BaseURLV2}/blog/gallery/update`,
  UpdateFestival: `${BaseURLV2}/blog/festival/update`,
  PostFileUpload: `${BaseURLV2}/blog/file/upload`,
  SessionVideoUpload: `${BaseURLV2}/sessions/upload-video`,
  SessionUploadedFiles: `${BaseURLV2}/sessions/uploaded-files`,
  SessionFilesUpload: `${BaseURLV2}/sessions/upload-file`,
  BlogFileDelete: `${BaseURLV2}/blog/file/destroy`,
  GetBlogFile: `${BaseURLV2}/blog/file/get-files`,
  DisableFestival: `${BaseURLV2}/blog/festival/trash`,
  SetModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/active-works`,
  SetCommentModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/comments/update-status`,
  DisableAlbum: `${BaseURLV2}/blog/gallery/trash`,
  SessionFilesDelete: `${BaseURLV2}/sessions/delete-file`,
  SessionHomeWorks: `${BaseURLV2}/sessions/get-homeworks`,
  SessionHomeWork: `${BaseURLV2}/sessions/get-homework`,
  SessionHomeWorkSetComment: `${BaseURLV2}/sessions/set-homework-comment`,
  SessionHomeWorkFiles: `${BaseURLV2}/sessions/get-homework-files`,
  CreateLesson: `${BaseURLV2}/lessons/create-lesson`,
  CreateParentTag: `${BaseURLV2}/parent-tags/set`,
  EditLesson: `${BaseURLV2}/lessons/update-lesson`,
  EditAssistantPermission: `${BaseURLV2}/schools/assistant-permission`,
  SchoolTeachers: `${BaseURLV2}/schools/get-teachers`,
  SchoolStudents: `${BaseURLV2}/schools/get-students`,
  SchoolAdvisers: `${BaseURLV2}/schools/get-advisers`,
  GetExcelImportReports: `${BaseURLV2}/import-excel/get-reports`,
  GetExcelImportReportsDetails: `${BaseURLV2}/import-excel/get-reports-details`,
  SchoolAdvisersExcel: `${BaseURLV2}/schools/get-advisers-export`,
  SchoolAssistants: `${BaseURLV2}/schools/get-assistants`,
  SchoolAssistantSetter: `${BaseURLV2}/schools/add-assistant`,
  SchoolStudentSetter: `${BaseURLV2}/schools/add-student`,
  SchoolTeacherSetter: `${BaseURLV2}/schools/add-teacher`,
  SchoolAdvisersSetter: `${BaseURLV2}/schools/add-adviser`,
  LessonExams: `${BaseURLV2}/lessons/`,
  DeleteAssistant: `${BaseURLV2}/schools/delete-assistant`,
  WorkShifts: `${BaseURLV2}/schools/get-work-shift`,
  UpdateWorkShift: `${BaseURLV2}/schools/set-work-shift`,
  SchoolParents: `${BaseURLV2}/schools/get-parents`,
  ParentSetter: `${BaseURLV2}/schools/add-parent`,
  ParentStudentSetter: `${BaseURLV2}/schools/add-parent-student`,
  ManagerReports: `${BaseURLV2}/reports/manager`,
  SchoolMajors: `${BaseURLV2}/majors/get-majors`,
  SchoolWorkbooks: `${BaseURLV2}/workbooks`,
  PromoteAdviser: `${BaseURLV2}/adviser`,
  GetAdviserChildren: `${BaseURLV2}/adviser/get-adviser-children`,
  SetAdviserChildren: `${BaseURLV2}/adviser/set-adviser-children`,
  DelAdviserChildren: `${BaseURLV2}/adviser/del-adviser-children`,
  SupportForms: `${BaseURLV2}/support-form`,
  getSupportFormQuestions: `${BaseURLV2}/support-form/get-support-form-questions`,
  CreateTags: `${BaseURLV2}/students/add-tag`,
  GetTags: `${BaseURLV2}/students/get-tags`,
  RemoveTag: `${BaseURLV2}/students/remove-tag`,
  deleteStudent: `${BaseURLV2}/students/delete`,
  UndoDeleteStudent: `${BaseURLV2}/students/undo-delete`,
  Adviser: `${BaseURLV2}/adviser`,
  Assistant: `${BaseURLV2}/schools/assistant`,
  deleteSupportForm: `${BaseURLV2}/support-form`,
  copySupportForm: `${BaseURLV2}/support-form/copy`,
  searchTag: `${BaseURLV2}/students/search-tag`,
  studentTag: `${BaseURLV2}/students/tags`,
  voipReport: `${BaseURLV2}/voip/report`,
  studentLoginReport: `${BaseURLV2}/reports/get-students-activity`,
  studentTopicReport: `${BaseURLV2}/reports/get-students-lesson-page-activity`,
  studentVoipReport: `${BaseURLV2}/reports/get-students-voip-report`,
  InputCalls: `${BaseURLV2}/voip/input-calls`,
  AllCallHistories: `${BaseURLV2}/voip/all-call-histories`,
  downloadFileCallHistory: `${BaseURLV2}/voip/download-history-file`,
  getAllSupportForms: `${BaseURLV2}/voip/all-call-histories`,

};

export const AssistantAPIRoutes = {
  Events: `${BaseURLV2}/school/`,
  ManagerEditBlogProfile: `${BaseURLV2}/blog/host/update`,
  Grades: `${BaseURLV2}/general/grades`,
  Schools: `${BaseURLV2}/schools/get-schools`,
  SchoolGrades: `${BaseURLV2}/grades/get-grades`,
  SchoolClassrooms: `${BaseURLV2}/classrooms/get-classrooms`,
  SearchUser: `${BaseURLV2}/general/search-user`,
  CreateClassroom: `${BaseURLV2}/classrooms/create-classrooms`,
  AddStudentInClassroom: `${BaseURLV2}/classrooms/add-student`,
  DeleteClassroom: `${BaseURLV2}/classrooms/delete-classrooms`,
  ClassroomStudents: `${BaseURLV2}/classrooms/get-classroom-students`,
  ClassroomLessons: `${BaseURLV2}/lessons/get-lessons`,
  LessonRecords: `${BaseURLV2}/lessons/get-recordings?page=`,
  SaveRecords: `${BaseURLV2}/lessons/save-recording`,
  ClassroomSessionComments: `${BaseURLV2}/sessions/get-questions`,
  ClassroomSessionAddComment: `${BaseURLV2}/sessions/set-question`,
  ClassroomSessions: `${BaseURLV2}/sessions/get-sessions?page=`,
  ClassroomSession: `${BaseURLV2}/sessions/session-detail`,
  CreateSession: `${BaseURLV2}/sessions/create-session`,
  DeleteSession: `${BaseURLV2}/sessions/delete-session`,
  DeleteStudentFromClassroom: `${BaseURLV2}/classrooms/delete-student`,
  DeleteLesson: `${BaseURLV2}/lessons/delete-lesson`,
  GetBlogValidate: `${BaseURLV2}/blog/host/get-host`,
  CreateBlog: `${BaseURLV2}/blog/host/create`,
  SearchCategory: `${BaseURLV2}/blog/category/search`,
  CreateCategory: `${BaseURLV2}/blog/category/create`,
  GetBlogPosts: `${BaseURLV2}/blog/content/get-contents?page=`,
  GetBlogAlbums: `${BaseURLV2}/blog/gallery/get-galleries?page=`,
  GetBlogFestivals: `${BaseURLV2}/blog/festival/get-festivals?page=`,
  GetFestivalArtEffectsList: `${BaseURLV2}/blog/festival/works/get-festival-works?page=`,
  GetPublicFestivalArtEffectsList: `${BaseURLV2}/blog/public/get-festivals/works/`,
  GetFestivalArtEffectDetail: `${BaseURLV2}/blog/festival/works/detail`,
  GetFestivalArtEffectComments: `${BaseURLV2}/blog/festival/works/comments/get-comments`,
  GetPublicFestivalArtEffectDetail: `${BaseURLV2}/blog/public/get-festivals/works/`,
  CheckFestivalAccess: `${BaseURLV2}/blog/festival/works/check-access`,
  JoinFestivalDraft: `${BaseURLV2}/blog/festival/works/draft`,
  AddFestivalArtEffect: `${BaseURLV2}/blog/festival/works/update`,
  NewPostDraft: `${BaseURLV2}/blog/content/draft`,
  NewAlbumDraft: `${BaseURLV2}/blog/gallery/draft`,
  NewFestivalDraft: `${BaseURLV2}/blog/festival/draft`,
  DisablePost: `${BaseURLV2}/blog/content/trash`,
  EnablePost: `${BaseURLV2}/blog/content/undo`,
  EnableGallery: `${BaseURLV2}/blog/gallery/undo`,
  EnableFestival: `${BaseURLV2}/blog/festival/undo`,
  GetSubCategory: `${BaseURLV2}/blog/category/get-categories`,
  UpdatePost: `${BaseURLV2}/blog/content/update`,
  UpdateAlbum: `${BaseURLV2}/blog/gallery/update`,
  UpdateFestival: `${BaseURLV2}/blog/festival/update`,
  PostFileUpload: `${BaseURLV2}/blog/file/upload`,
  SessionVideoUpload: `${BaseURLV2}/sessions/upload-video`,
  SessionUploadedFiles: `${BaseURLV2}/sessions/uploaded-files`,
  SessionFilesUpload: `${BaseURLV2}/sessions/upload-file`,
  BlogFileDelete: `${BaseURLV2}/blog/file/destroy`,
  GetBlogFile: `${BaseURLV2}/blog/file/get-files`,
  DisableFestival: `${BaseURLV2}/blog/festival/trash`,
  SetModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/active-works`,
  SetCommentModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/comments/update-status`,
  DisableAlbum: `${BaseURLV2}/blog/gallery/trash`,
  SessionFilesDelete: `${BaseURLV2}/sessions/delete-file`,
  SessionHomeWorks: `${BaseURLV2}/sessions/get-homeworks`,
  SessionHomeWork: `${BaseURLV2}/sessions/get-homework`,
  SessionHomeWorkSetComment: `${BaseURLV2}/sessions/set-homework-comment`,
  SessionHomeWorkFiles: `${BaseURLV2}/sessions/get-homework-files`,
  CreateLesson: `${BaseURLV2}/lessons/create-lesson`,
  EditLesson: `${BaseURLV2}/lessons/update-lesson`,
  EditAssistantPermission: `${BaseURLV2}/schools/assistant-permission`,
  SchoolTeachers: `${BaseURLV2}/schools/get-teachers`,
  SchoolStudents: `${BaseURLV2}/schools/get-students`,
  SchoolAssistants: `${BaseURLV2}/schools/get-assistants`,
  SchoolAssistantSetter: `${BaseURLV2}/schools/add-assistant`,
  SchoolStudentSetter: `${BaseURLV2}/schools/add-student`,
  SchoolTeacherSetter: `${BaseURLV2}/schools/add-teacher`,
};

export const TeacherAPIRoutes = {
  JointExam: `${BaseURLV2}/total-exam`,
  Events: `${BaseURLV2}/school/`,
  MyEvents: `${BaseURLV2}/personal-event/`,
  MyEventsParticipants: `${BaseURLV2}/personal-event/get-event-participants/`,
  MyEventsCheck: `${BaseURLV2}/personal-event/check`,
  MyEventsCreate: `${BaseURLV2}/personal-event/create`,
  MyEventsSessionCreate: `${BaseURLV2}/personal-event/create-session`,
  MyEventsSessionGet: `${BaseURLV2}/personal-event/get-session`,
  MyEventsPurchased: `${BaseURLV2}/personal-event/get-event-purchased`,
  MyEventsEventGet: `${BaseURLV2}/personal-event/get/`,
  MyEventsSessionDelete: `${BaseURLV2}/personal-event/delete-session`,
  MyEventsGet: `${BaseURLV2}/personal-event/get/`,
  MyEventsImageUpload: `${BaseURLV2}/personal-event/upload`,
  ManagerEditBlogProfile: `${BaseURLV2}/blog/host/update`,
  Grades: `${BaseURLV2}/general/grades`,
  Schools: `${BaseURLV2}/schools/get-schools`,
  SchoolGrades: `${BaseURLV2}/grades/get-grades`,
  SchoolClassrooms: `${BaseURLV2}/classrooms/get-classrooms`,
  SchoolClassroomsGrade: `${BaseURLV2}/classrooms/get-classrooms-grade`,
  ClassGroups: `${BaseURLV2}/classrooms/groups/`,
  SearchUser: `${BaseURLV2}/general/search-user`,
  CreateClassroom: `${BaseURLV2}/classrooms/create-classrooms`,
  AddStudentInClassroom: `${BaseURLV2}/classrooms/add-student`,
  DeleteClassroom: `${BaseURLV2}/classrooms/delete-classrooms`,
  ClassroomStudents: `${BaseURLV2}/classrooms/get-classroom-students`,
  ClassroomLessons: `${BaseURLV2}/lessons/get-lessons`,
  GetAllClassrooms: `${BaseURLV2}/lessons/get-classrooms`,
  CopyLessonToClassroom: `${BaseURLV2}/lessons/copy-lesson-to-classroom`,
  LessonRecords: `${BaseURLV2}/lessons/get-recordings?page=`,
  ClassroomSessionComments: `${BaseURLV2}/sessions/get-questions`,
  ClassroomSessionAddComment: `${BaseURLV2}/sessions/set-question`,
  ClassroomSessions: `${BaseURLV2}/sessions/get-sessions?page=`,
  ClassroomSession: `${BaseURLV2}/sessions/session-detail`,
  CreateSession: `${BaseURLV2}/sessions/create-session`,
  CreateLessonPages: `${BaseURLV2}/lesson-pages/create`,
  ClassroomLessonEdit: `${BaseURLV2}/lesson-pages/edit/`,
  ClassroomLesson: `${BaseURLV2}/lesson-pages/show`,
  ClassroomLessonPages: `${BaseURLV2}/lesson-pages/?page=`,
  ClassroomLessonPagesImagesUpload: `${BaseURLV2}/lesson-pages/images/upload`,
  ClassroomLessonPagesFilesUpload: `${BaseURLV2}/lesson-pages/files/upload`,
  ClassroomLessonPagesVideosUpload: `${BaseURLV2}/lesson-pages/videos/upload`,
  ClassroomLessonPagesVoicesUpload: `${BaseURLV2}/lesson-pages/voices/upload`,
  ClassroomLessonPagesImages: `${BaseURLV2}/lesson-pages/images`,
  ClassroomLessonPagesVoices: `${BaseURLV2}/lesson-pages/voices`,
  ClassroomLessonPagesFiles: `${BaseURLV2}/lesson-pages/files`,
  ClassroomLessonPagesVideos: `${BaseURLV2}/lesson-pages/videos`,
  ClassroomLessonPagesImagesRemove: `${BaseURLV2}/lesson-pages/images/remove`,
  ClassroomLessonPagesFilesRemove: `${BaseURLV2}/lesson-pages/files/remove`,
  ClassroomLessonPagesVideosRemove: `${BaseURLV2}/lesson-pages/videos/remove`,
  ClassroomLessonPagesVideosConvert: `${BaseURLV2}/lesson-pages/videos/convert-video`,
  ClassroomLessonPagesVideosConvertDetail: `${BaseURLV2}/lesson-pages/videos/convert-detail`,
  ClassroomLessonPagesVideosConvertRemove: `${BaseURLV2}/lesson-pages/videos/convert-remove`,
  ClassroomLessonPagesVoicesRemove: `${BaseURLV2}/lesson-pages/voices/remove`,
  LockSession: `${BaseURLV2}/sessions/lock-session`,
  UnLockSession: `${BaseURLV2}/sessions/unlock-session`,
  DeleteSession: `${BaseURLV2}/sessions/delete-session`,
  DeleteLessonPage: `${BaseURLV2}/lesson-pages/delete`,
  DeleteStudentFromClassroom: `${BaseURLV2}/classrooms/delete-student`,
  DeleteLesson: `${BaseURLV2}/lessons/delete-lesson`,
  LessonExams: `${BaseURLV2}/lessons/`,
  GetAvailableLessonsForExam: `${BaseURLV2}/lessons/general/lessons`,
  GetBlogValidate: `${BaseURLV2}/blog/host/get-host`,
  CreateBlog: `${BaseURLV2}/blog/host/create`,
  SearchCategory: `${BaseURLV2}/blog/category/search`,
  CreateCategory: `${BaseURLV2}/blog/category/create`,
  GetBlogPosts: `${BaseURLV2}/blog/content/get-contents?page=`,
  GetBlogAlbums: `${BaseURLV2}/blog/gallery/get-galleries?page=`,
  GetBlogFestivals: `${BaseURLV2}/blog/festival/get-festivals?page=`,
  GetFestivalArtEffectsList: `${BaseURLV2}/blog/festival/works/get-festival-works?page=`,
  GetPublicFestivalArtEffectsList: `${BaseURLV2}/blog/public/get-festivals/works/`,
  GetFestivalArtEffectDetail: `${BaseURLV2}/blog/festival/works/detail`,
  GetFestivalArtEffectComments: `${BaseURLV2}/blog/festival/works/comments/get-comments`,
  GetPublicFestivalArtEffectDetail: `${BaseURLV2}/blog/public/get-festivals/works/`,
  CheckFestivalAccess: `${BaseURLV2}/blog/festival/works/check-access`,
  JoinFestivalDraft: `${BaseURLV2}/blog/festival/works/draft`,
  AddFestivalArtEffect: `${BaseURLV2}/blog/festival/works/update`,
  NewPostDraft: `${BaseURLV2}/blog/content/draft`,
  NewAlbumDraft: `${BaseURLV2}/blog/gallery/draft`,
  NewFestivalDraft: `${BaseURLV2}/blog/festival/draft`,
  DisablePost: `${BaseURLV2}/blog/content/trash`,
  EnablePost: `${BaseURLV2}/blog/content/undo`,
  EnableGallery: `${BaseURLV2}/blog/gallery/undo`,
  EnableFestival: `${BaseURLV2}/blog/festival/undo`,
  GetSubCategory: `${BaseURLV2}/blog/category/get-categories`,
  UpdatePost: `${BaseURLV2}/blog/content/update`,
  UpdateAlbum: `${BaseURLV2}/blog/gallery/update`,
  UpdateFestival: `${BaseURLV2}/blog/festival/update`,
  PostFileUpload: `${BaseURLV2}/blog/file/upload`,
  SessionVideoUpload: `${BaseURLV2}/sessions/upload-video`,
  SessionUploadedFiles: `${BaseURLV2}/sessions/uploaded-files`,
  SessionFilesUpload: `${BaseURLV2}/sessions/upload-file`,
  BlogFileDelete: `${BaseURLV2}/blog/file/destroy`,
  GetBlogFile: `${BaseURLV2}/blog/file/get-files`,
  DisableFestival: `${BaseURLV2}/blog/festival/trash`,
  SetModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/active-works`,
  SetCommentModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/comments/update-status`,
  DisableAlbum: `${BaseURLV2}/blog/gallery/trash`,
  SessionFilesDelete: `${BaseURLV2}/sessions/delete-file`,
  SessionHomeWorks: `${BaseURLV2}/sessions/get-homeworks`,
  SessionHomeWork: `${BaseURLV2}/sessions/get-homework`,
  SessionHomeWorkSetComment: `${BaseURLV2}/sessions/set-homework-comment`,
  SessionHomeWorkFiles: `${BaseURLV2}/sessions/get-homework-files`,
  CreateLesson: `${BaseURLV2}/lessons/create-lesson`,
  EditLesson: `${BaseURLV2}/lessons/update-lesson`,
  EditAssistantPermission: `${BaseURLV2}/schools/assistant-permission`,
  SchoolTeachers: `${BaseURLV2}/schools/get-teachers`,
  SchoolStudents: `${BaseURLV2}/schools/get-students`,
  SchoolAssistants: `${BaseURLV2}/schools/get-assistants`,
  SchoolAssistantSetter: `${BaseURLV2}/schools/add-assistant`,
  SchoolStudentSetter: `${BaseURLV2}/schools/add-student`,
  SchoolTeacherSetter: `${BaseURLV2}/schools/add-teacher`,
  HomeWorkUploadedFiles: `${BaseURLV2}/sessions/get-homework-files`,
  DeleteChapter: `${BaseURLV2}/lessons/delete-chapter`,
  DeleteSubject: `${BaseURLV2}/lessons/delete-subject`,
  UploadTreeSubjectFiles: `${BaseURLV2}/lessons/educate-tree/upload-tree-files`,
  CreatedQuiz: `${BaseURLV2}/lesson-pages/exams/save/`,
  GetQuiz: `${BaseURLV2}/lesson-pages/exams/`,
  UpdateQuiz: `${BaseURLV2}/lesson-pages/exams/update/`,
  DeleteQuiz: `${BaseURLV2}/lesson-pages/exams/remove`,
  CreatedQuizQuestions: `${BaseURLV2}/lesson-pages/questions/save`,
  GetQuizQuestions: `${BaseURLV2}/lesson-pages/questions/`,
  UpdateQuizQuestions: `${BaseURLV2}/lesson-pages/questions/update/`,
  DeleteQuizQuestions: `${BaseURLV2}/lesson-pages/questions/remove`,
};

export const AdviserAPIRoutes = {
  SearchAllamehStudent: `${BaseURLV2}/adviser/search-allameh-student/`,
  GetAllamehTickets: `${BaseURLV2}/support`,
  CreateTicket: `${BaseURLV2}/support/create-message`,
  GetTicket: `${BaseURLV2}/support/get-messages`,
  adviser: `${BaseURLV2}/adviser`,
  GetAllamehExams: `${BaseURLV2}/adviser/get-allameh-school-exam/`,
  GetAllamehStudentExams: `${BaseURLV2}/adviser/get-allameh-student-exam/`,
  GetAllamehStudentExamsReport: `${BaseURLV2}/adviser/get-allameh-student-exam-report/`,
  GetSchoolAdvisers: `${BaseURLV2}/adviser/get-school-advisers`,
  GetAdviserStudents: `${BaseURLV2}/adviser/get-adviser-students`,
  SetAdviserStudents: `${BaseURLV2}/adviser/set-adviser-students`,
  GetAdviserSupports: `${BaseURLV2}/support-form/get-adviser-support-forms`,
  SupportForm: `${BaseURLV2}/support-form`,
  WorkShifts: `${BaseURLV2}/schools/get-work-shift`,
  UpdateWorkShift: `${BaseURLV2}/schools/set-work-shift`,
  getStudentProfileForm: `${BaseURLV2}/support-form/get-student-profile-forms`,
  voipD: `${BaseURLV2}/voip/define-direct-call`,
  voipG: `${BaseURLV2}/voip/define-group-call`,
  voipGroup: `${BaseURLV2}/voip/make-group-call`,
  voipDirect: `${BaseURLV2}/voip/make-direct-call`,
  voipEmergency: `${BaseURLV2}/voip/make-emergency-call`,
  getVoipGroup: `${BaseURLV2}/voip/get-group-calls`,
  voipCall: `${BaseURLV2}/voip`,
  getStudentCallHistories: `${BaseURLV2}/support-form/get-students-call-report-with-id`,
  InterruptedCallsList: `${BaseURLV2}/support-form/get-students-support-form-interrupted-calls-list`,
  changeStudentSupportFormStatus: `${BaseURLV2}/support-form/change-student-support-form-status`,
  getStudentSupportFormStatus: `${BaseURLV2}/support-form/get-student-support-form-status`,



  // getSupportForm: `${BaseURLV2}/support-form/get-adviser-support-forms`,
  getCall: `${BaseURLV2}/voip/get-calls`,
  SchoolAdvisers: `${BaseURLV2}/schools/get-advisers`,
  assessments: `${BaseURLV2}/assessments`,
  user: `${BaseURLV2}/user`,
  InputCalls: `${BaseURLV2}/voip/input-calls`,
  getQuestionHintWithStudentAnswered: `${BaseURLV2}/support-form`,

};

export const ParentAPIRoutes = {
  Events: `${BaseURLV2}/school/`,
  ManagerEditBlogProfile: `${BaseURLV2}/blog/host/update`,
  Grades: `${BaseURLV2}/general/grades`,
  SchoolGrades: `${BaseURLV2}/grades/get-grades`,
  Schools: `${BaseURLV2}/schools/get-schools`,
  SchoolClassrooms: `${BaseURLV2}/classrooms/get-classrooms`,
  SearchUser: `${BaseURLV2}/general/search-user`,
  CreateClassroom: `${BaseURLV2}/classrooms/create-classrooms`,
  AddStudentInClassroom: `${BaseURLV2}/classrooms/add-student`,
  DeleteClassroom: `${BaseURLV2}/classrooms/delete-classrooms`,
  ClassroomStudents: `${BaseURLV2}/classrooms/get-classroom-students`,
  ClassroomLessons: `${BaseURLV2}/lessons/get-lessons`,
  LessonRecords: `${BaseURLV2}/lessons/get-recordings?page=`,
  ClassroomSessionComments: `${BaseURLV2}/sessions/get-questions`,
  ClassroomSessionAddComment: `${BaseURLV2}/sessions/set-question`,
  ClassroomSessions: `${BaseURLV2}/sessions/get-sessions?page=`,
  ClassroomSession: `${BaseURLV2}/sessions/session-detail`,
  CreateSession: `${BaseURLV2}/sessions/create-session`,
  DeleteSession: `${BaseURLV2}/sessions/delete-session`,
  DeleteStudentFromClassroom: `${BaseURLV2}/classrooms/delete-student`,
  DeleteLesson: `${BaseURLV2}/lessons/delete-lesson`,
  GetBlogValidate: `${BaseURLV2}/blog/host/get-host`,
  CreateBlog: `${BaseURLV2}/blog/host/create`,
  SearchCategory: `${BaseURLV2}/blog/category/search`,
  CreateCategory: `${BaseURLV2}/blog/category/create`,
  GetBlogPosts: `${BaseURLV2}/blog/content/get-contents?page=`,
  GetBlogAlbums: `${BaseURLV2}/blog/gallery/get-galleries?page=`,
  GetBlogFestivals: `${BaseURLV2}/blog/festival/get-festivals?page=`,
  GetFestivalArtEffectsList: `${BaseURLV2}/blog/festival/works/get-festival-works?page=`,
  GetPublicFestivalArtEffectsList: `${BaseURLV2}/blog/public/get-festivals/works/`,
  GetFestivalArtEffectDetail: `${BaseURLV2}/blog/festival/works/detail`,
  GetFestivalArtEffectComments: `${BaseURLV2}/blog/festival/works/comments/get-comments`,
  GetPublicFestivalArtEffectDetail: `${BaseURLV2}/blog/public/get-festivals/works/`,
  CheckFestivalAccess: `${BaseURLV2}/blog/festival/works/check-access`,
  JoinFestivalDraft: `${BaseURLV2}/blog/festival/works/draft`,
  AddFestivalArtEffect: `${BaseURLV2}/blog/festival/works/update`,
  NewPostDraft: `${BaseURLV2}/blog/content/draft`,
  NewAlbumDraft: `${BaseURLV2}/blog/gallery/draft`,
  NewFestivalDraft: `${BaseURLV2}/blog/festival/draft`,
  DisablePost: `${BaseURLV2}/blog/content/trash`,
  EnablePost: `${BaseURLV2}/blog/content/undo`,
  EnableGallery: `${BaseURLV2}/blog/gallery/undo`,
  EnableFestival: `${BaseURLV2}/blog/festival/undo`,
  GetSubCategory: `${BaseURLV2}/blog/category/get-categories`,
  UpdatePost: `${BaseURLV2}/blog/content/update`,
  UpdateAlbum: `${BaseURLV2}/blog/gallery/update`,
  UpdateFestival: `${BaseURLV2}/blog/festival/update`,
  PostFileUpload: `${BaseURLV2}/blog/file/upload`,
  SessionVideoUpload: `${BaseURLV2}/sessions/upload-video`,
  SessionUploadedFiles: `${BaseURLV2}/sessions/uploaded-files`,
  HomeWorkUploadedFiles: `${BaseURLV2}/sessions/get-homework-files`,
  SessionFilesUpload: `${BaseURLV2}/sessions/upload-file`,
  HomeWorkFilesUpload: `${BaseURLV2}/sessions/upload-homework-file`,
  BlogFileDelete: `${BaseURLV2}/blog/file/destroy`,
  GetBlogFile: `${BaseURLV2}/blog/file/get-files`,
  DisableFestival: `${BaseURLV2}/blog/festival/trash`,
  SetModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/active-works`,
  SetCommentModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/comments/update-status`,
  DisableAlbum: `${BaseURLV2}/blog/gallery/trash`,
  SessionFilesDelete: `${BaseURLV2}/sessions/delete-file`,
  HomeWorkFilesDelete: `${BaseURLV2}/sessions/delete-homework-file`,
  SessionHomeWorks: `${BaseURLV2}/sessions/get-homeworks`,
  AddHomeWork: `${BaseURLV2}/sessions/create-homework`,
  SessionHomeWork: `${BaseURLV2}/sessions/get-homework`,
  SessionHomeWorkSetComment: `${BaseURLV2}/sessions/set-homework-comment`,
  SessionHomeWorkFiles: `${BaseURLV2}/sessions/get-homework-files`,
  CreateLesson: `${BaseURLV2}/lessons/create-lesson`,
  EditLesson: `${BaseURLV2}/lessons/update-lesson`,
  EditAssistantPermission: `${BaseURLV2}/schools/assistant-permission`,
  SchoolTeachers: `${BaseURLV2}/schools/get-teachers`,
  SchoolStudents: `${BaseURLV2}/schools/get-students`,
  SchoolAssistants: `${BaseURLV2}/schools/get-assistants`,
  SchoolAssistantSetter: `${BaseURLV2}/schools/add-assistant`,
  SchoolStudentSetter: `${BaseURLV2}/schools/add-student`,
  SchoolTeacherSetter: `${BaseURLV2}/schools/add-teacher`,
};

export const StudentAPIRoutes = {
  JointExam: `${BaseURLV2}/total-exam`,
  Messages: `${BaseURLV2}/school/`,
  Events: `${BaseURLV2}/school/`,
  LessonExams: `${BaseURLV2}/lessons/`,
  ManagerEditBlogProfile: `${BaseURLV2}/blog/host/update`,
  Grades: `${BaseURLV2}/general/grades`,
  SchoolGrades: `${BaseURLV2}/grades/get-grades`,
  Schools: `${BaseURLV2}/schools/get-schools`,
  SchoolClassrooms: `${BaseURLV2}/classrooms/get-classrooms`,
  Wallet: `${BaseURLV2}/wallet?page=`,
  WalletCallback: `${BaseURLV2}/wallet/callback`,
  IncreaseInventory: `${BaseURLV2}/wallet/increase-inventory`,
  SearchUser: `${BaseURLV2}/general/search-user`,
  CreateClassroom: `${BaseURLV2}/classrooms/create-classrooms`,
  AddStudentInClassroom: `${BaseURLV2}/classrooms/add-student`,
  DeleteClassroom: `${BaseURLV2}/classrooms/delete-classrooms`,
  ClassroomStudents: `${BaseURLV2}/classrooms/get-classroom-students`,
  ClassroomLessons: `${BaseURLV2}/lessons/get-lessons`,
  LessonRecords: `${BaseURLV2}/lessons/get-recordings?page=`,
  ClassroomSessionComments: `${BaseURLV2}/sessions/get-questions`,
  ClassroomSessionAddComment: `${BaseURLV2}/sessions/set-question`,
  ClassroomSessions: `${BaseURLV2}/sessions/get-sessions?page=`,
  ClassroomSession: `${BaseURLV2}/sessions/session-detail`,
  ClassroomLessonPagesShow: `${BaseURLV2}/lesson-pages/show`,
  ClassroomLessonPagesRateSave: `${BaseURLV2}/lesson-pages/rating/save`,
  ClassroomLessonPagesGetStudentScore: `${BaseURLV2}/lesson-pages/rating/get-student-score`,
  ClassroomLessonPagesCommentSave: `${BaseURLV2}/lesson-pages/comments/save`,
  ClassroomLessonPagesCommentGet: `${BaseURLV2}/lesson-pages/comments/`,
  ClassroomLessonPagesViewSet: `${BaseURLV2}/lesson-pages/view/save`,
  ClassroomLessonPagesViewGet: `${BaseURLV2}/lesson-pages/view/`,
  ClassroomLessonPageExam: `${BaseURLV2}/lesson-pages/exam-student/exam/`,
  ClassroomLessonPageExamStar: `${BaseURLV2}/lesson-pages/exam-student/exam/start/`,
  ClassroomLessonPageExamEnd: `${BaseURLV2}/lesson-pages/exam-student/exam/end`,
  ClassroomLessonPageExamInterimReport: `${BaseURLV2}/lesson-pages/exam-student/exam/interim-report`,
  ClassroomLessonPageExamReport: `${BaseURLV2}/lesson-pages/exam-student/exam/report`,
  CreateSession: `${BaseURLV2}/sessions/create-session`,
  DeleteSession: `${BaseURLV2}/sessions/delete-session`,
  DeleteStudentFromClassroom: `${BaseURLV2}/classrooms/delete-student`,
  DeleteLesson: `${BaseURLV2}/lessons/delete-lesson`,
  GetBlogValidate: `${BaseURLV2}/blog/host/get-host`,
  CreateBlog: `${BaseURLV2}/blog/host/create`,
  SearchCategory: `${BaseURLV2}/blog/category/search`,
  CreateCategory: `${BaseURLV2}/blog/category/create`,
  GetBlogPosts: `${BaseURLV2}/blog/content/get-contents?page=`,
  GetBlogAlbums: `${BaseURLV2}/blog/gallery/get-galleries?page=`,
  GetBlogFestivals: `${BaseURLV2}/blog/festival/get-festivals?page=`,
  GetFestivalArtEffectsList: `${BaseURLV2}/blog/festival/works/get-festival-works?page=`,
  GetPublicFestivalArtEffectsList: `${BaseURLV2}/blog/public/get-festivals/works/`,
  GetFestivalArtEffectDetail: `${BaseURLV2}/blog/festival/works/detail`,
  GetFestivalArtEffectComments: `${BaseURLV2}/blog/festival/works/comments/get-comments`,
  GetPublicFestivalArtEffectDetail: `${BaseURLV2}/blog/public/get-festivals/works/`,
  CheckFestivalAccess: `${BaseURLV2}/blog/festival/works/check-access`,
  JoinFestivalDraft: `${BaseURLV2}/blog/festival/works/draft`,
  AddFestivalArtEffect: `${BaseURLV2}/blog/festival/works/update`,
  NewPostDraft: `${BaseURLV2}/blog/content/draft`,
  NewAlbumDraft: `${BaseURLV2}/blog/gallery/draft`,
  NewFestivalDraft: `${BaseURLV2}/blog/festival/draft`,
  DisablePost: `${BaseURLV2}/blog/content/trash`,
  EnablePost: `${BaseURLV2}/blog/content/undo`,
  EnableGallery: `${BaseURLV2}/blog/gallery/undo`,
  EnableFestival: `${BaseURLV2}/blog/festival/undo`,
  GetSubCategory: `${BaseURLV2}/blog/category/get-categories`,
  UpdatePost: `${BaseURLV2}/blog/content/update`,
  UpdateAlbum: `${BaseURLV2}/blog/gallery/update`,
  UpdateFestival: `${BaseURLV2}/blog/festival/update`,
  PostFileUpload: `${BaseURLV2}/blog/file/upload`,
  SessionVideoUpload: `${BaseURLV2}/sessions/upload-video`,
  SessionUploadedFiles: `${BaseURLV2}/sessions/uploaded-files`,
  HomeWorkUploadedFiles: `${BaseURLV2}/sessions/get-homework-files`,
  SessionFilesUpload: `${BaseURLV2}/sessions/upload-file`,
  HomeWorkFilesUpload: `${BaseURLV2}/sessions/upload-homework-file`,
  BlogFileDelete: `${BaseURLV2}/blog/file/destroy`,
  GetBlogFile: `${BaseURLV2}/blog/file/get-files`,
  DisableFestival: `${BaseURLV2}/blog/festival/trash`,
  SetModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/active-works`,
  SetCommentModeFestivalArtEffect: `${BaseURLV2}/blog/festival/works/comments/update-status`,
  DisableAlbum: `${BaseURLV2}/blog/gallery/trash`,
  SessionFilesDelete: `${BaseURLV2}/sessions/delete-file`,
  HomeWorkFilesDelete: `${BaseURLV2}/sessions/delete-homework-file`,
  SessionHomeWorks: `${BaseURLV2}/sessions/get-homeworks`,
  AddHomeWork: `${BaseURLV2}/sessions/create-homework`,
  SessionHomeWork: `${BaseURLV2}/sessions/get-homework`,
  SessionHomeWorkSetComment: `${BaseURLV2}/sessions/set-homework-comment`,
  SessionHomeWorkFiles: `${BaseURLV2}/sessions/get-homework-files`,
  CreateLesson: `${BaseURLV2}/lessons/create-lesson`,
  EditLesson: `${BaseURLV2}/lessons/update-lesson`,
  EditAssistantPermission: `${BaseURLV2}/schools/assistant-permission`,
  SchoolTeachers: `${BaseURLV2}/schools/get-teachers`,
  SchoolStudents: `${BaseURLV2}/schools/get-students`,
  SchoolAssistants: `${BaseURLV2}/schools/get-assistants`,
  SchoolAssistantSetter: `${BaseURLV2}/schools/add-assistant`,
  SchoolStudentSetter: `${BaseURLV2}/schools/add-student`,
  SchoolTeacherSetter: `${BaseURLV2}/schools/add-teacher`,
};
export const ProfileAPIRoutes = {
  setProfileUser: `${BaseURLV2}/profile/profile`,
  profileUser: `${BaseURLV2}/profile/get-data`,
  profileUploadAvatar: `${BaseURLV2}/profile/upload-avatar`,
  profileRemoveAvatar: `${BaseURLV2}/profile/upload-avatar-remove`,
  profileUploadVideo: `${BaseURLV2}/profile/upload-video`,
  profileRemoveVideo: `${BaseURLV2}/profile/upload-video-remove`,
  profileCheckUsername: `${BaseURLV2}/profile/check-username`,
  profileSetUsername: `${BaseURLV2}/profile/set-username`,
};
